<template>
  <div>
    <b-modal
      v-model="modalShow"
      :size="size"
      :title="title || 'More Detail'"
      scrollable
      hide-footer
      centered
    >
      <div v-if="contentType === 'text'">
        <p class="text-break">{{ content }}</p>
      </div>
      <div v-if="contentType === 'json'">
        <b-tooltip target="tooltip-target-1" triggers="hover">
          {{ textTooltipCopy }}
        </b-tooltip>
        <b-button
          size="sm"
          variant="dark"
          class="mb-3"
          @click="doCopy(content)"
          id="tooltip-target-1"
        >
          <i class="far fa-copy"></i> Copy Json to clipboard
        </b-button>
        <vue-json-pretty :data="JSON.parse(content)"> </vue-json-pretty>
      </div>
    </b-modal>
  </div>
</template>

<script>
// load package
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  name: "ModalMoreDetail",
  components: {
    VueJsonPretty,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    contentType: {
      type: String,
      default: "text", // text, json
    },
    size: {
      type: String,
      default: "lg", // sizes are sm, lg, and xl.
    },
    title: {
      type: String,
      default: "More Detail",
    },
    content: {
      type: String,
      default: "text",
    },
  },
  data() {
    return {
      textTooltipCopy: "Copy",
    };
  },
  created() {
    // console.log(5555);
    // console.log(this.content);
  },
  computed: {
    modalShow: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    doCopy: function (message) {
      let vm = this;
      var text = message;
      navigator.clipboard.writeText(text).then(
        function () {
          console.log("Async: Copying to clipboard was successful!");
          vm.textTooltipCopy = "Copied!";
          setTimeout(() => {
            vm.textTooltipCopy = "Copy";
          }, 1000);
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
    },
  },
};
</script>

<style lang="css" scoped></style>
